// extracted by mini-css-extract-plugin
export default {"root":"Breadcrumbs_root__6+EXd","item":"Breadcrumbs_item__pS8QQ","clickable":"Breadcrumbs_clickable__LaXrr","home":"Breadcrumbs_home__oJGmp"};